import fetch from 'logic/rest/FetchProvider';
import { qualifyUrl } from 'util/URLUtils';
import EnterpriseApiRoutes from 'common/ApiRoutes';
import type { EventCategories } from 'security-content/types';

export default function getEventTypeCategories(): Promise<EventCategories> {
  return fetch('GET', qualifyUrl(EnterpriseApiRoutes.ContentUI.eventTypeCategory().url));
}
